export const FORM_CODE_FF009 = 'FF009';

/** Personal information consent PDF page count (rules + sign-off). */
export const CAREER_UP_CONSENT_PAGE_COUNT = 3;

export type CareerUpApplicationStep = 'confirmNoCard' | 'readConsentDocument' | 'agreeApply';

export type YesNo = 'yes' | 'no';

export interface CareerUpApplicationFormValues {
  confirmNoCard?: YesNo;
  consentDocumentRead?: 'true' | 'false';
  agreeApply?: 'true' | 'false';
}
